import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=13868e47&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=13868e47&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13868e47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13868e47')) {
      api.createRecord('13868e47', component.options)
    } else {
      api.reload('13868e47', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=13868e47&scoped=true", function () {
      api.rerender('13868e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/myQualification/components/UploadImage.vue"
export default component.exports